import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '@/lib/i18n';

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => {
        return localStorage.getItem('avp_lang') || 'fr';
    });

    useEffect(() => {
        localStorage.setItem('avp_lang', lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (path) => {
        const parts = path.split('.');
        let current = translations[lang];
        for (const p of parts) {
            if (current == null) return path;
            current = current[p];
        }
        return current ?? path;
    };

    return (
        <LangContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LangContext.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error('useLang must be used within LangProvider');
    return ctx;
}
